
import { API } from 'aws-amplify';

class CountriesService {

   getCountries = async () => {
      var ReturnObj = [];
      await API.get('IAPI', 'Countries/countries/')
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }

   getCountriesOptions() {
      return API.get('IAPI', 'Countries/countries/').then(
         data => {
            return data.map(
               item => {
                  return {value: item.countryCode, label: item.country}
               }
            )
         }
      ).catch(error=>{
        // console.log(error);
         return []
      })
   }

}

export default new CountriesService();